import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.4_@babel+core@7.28.0_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.89.2/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/Images/WhySylndr/howItWorks1.svg");
;
import(/* webpackMode: "eager" */ "/app/public/Images/WhySylndr/howItWorks2.svg");
;
import(/* webpackMode: "eager" */ "/app/public/Images/WhySylndr/howItWorks3.svg");
;
import(/* webpackMode: "eager" */ "/app/public/Images/WhySylndr/howItWorks4.svg");
;
import(/* webpackMode: "eager" */ "/app/public/Images/WhySylndr/howItWorks5.svg");
;
import(/* webpackMode: "eager" */ "/app/public/Images/WhySylndr/howItWorks6.svg");
;
import(/* webpackMode: "eager" */ "/app/public/Images/WhySylndr/service1.svg");
;
import(/* webpackMode: "eager" */ "/app/public/Images/WhySylndr/service2.svg");
;
import(/* webpackMode: "eager" */ "/app/public/Images/WhySylndr/service3.svg");
;
import(/* webpackMode: "eager" */ "/app/public/Images/WhySylndr/sylndr-certified.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/shared/typography/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/testimonialVidSection/vid-testimonials.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/why-sylndr/how-it-works/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/why-sylndr/mobile-header/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/why-sylndr/mobile-tabs/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/why-sylndr/why-sylndr.page.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/why-sylndr/sylndr-certified-section/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/translations/client-setup.ts");
